import { useCallback, useContext, useEffect, useMemo, useState } from "react";

import type { UnactivatedMember } from "@storyboard/web-client";
import { client } from "@/config";
import { WorkspaceContext } from "@/models/StateProviders/workspaceProvider";

export function useUnactivatedMembers(filter?: string[]) {
  const { currentWorkspaceId } = useContext(WorkspaceContext);
  const [unactivatedMembers, setUnactivatedMembers] = useState<UnactivatedMember[]>([]);

  const fetchUnactivatedMembers = useCallback(async () => {
    if (!currentWorkspaceId) return;
    try {
      const result = await client.processRequest(
        client.workspacesClient.membershipsUnactivatedDetail(currentWorkspaceId),
      );

      const members = result?.members ?? [];
      const roleFilter = filter != null && filter.length > 0 ? filter : null;
      const data = roleFilter ? members.filter((member) => roleFilter.includes(member.role)) : members;

      setUnactivatedMembers(data);
    } catch {
      setUnactivatedMembers([]);
    }
  }, [currentWorkspaceId, filter]);

  useEffect(() => {
    fetchUnactivatedMembers();
  }, [fetchUnactivatedMembers]);

  const unactivatedMembershipIds = useMemo(
    () => new Set(unactivatedMembers.map((m) => m.membershipId)),
    [unactivatedMembers],
  );

  return {
    unactivatedMembers,
    unactivatedMembershipIds,
    refetch: fetchUnactivatedMembers,
  };
}
